// La bottega / il laboratorio: foto, video, descrizione, storia e riconoscimenti
import React from 'react';
import { Award, Calendar, MapPin } from 'lucide-react';
import ShopVideo from '../ShopVideo';
import { CERTIFICATIONS } from '../../components/MadeInItaly';
import { optimizeImageUrl } from '../../utils/imageUrl';
import { useShop } from '../ShopContext';
import { PageHeader, Section } from '../ShopUi';

export default function ShopAbout() {
  const { crafter, name, style } = useShop();
  const photos = crafter.cover_images?.length ? crafter.cover_images : (crafter.cover_image ? [crafter.cover_image] : []);

  return (
    <div data-testid="shop-about">
      <PageHeader title={crafter.storefront_section_name || 'La bottega'} subtitle={crafter.storefront_motto} />
      <Section>
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3 space-y-6">
            {crafter.bio && <p className="text-lg text-slate-700 leading-relaxed whitespace-pre-line">{crafter.bio}</p>}
            {crafter.workshop_story && (
              <div>
                <h2 className={`${style.heading} text-2xl text-slate-900 mb-3`}>La nostra storia</h2>
                <p className="text-slate-600 leading-relaxed whitespace-pre-line">{crafter.workshop_story}</p>
              </div>
            )}
            {Array.isArray(crafter.materials) && crafter.materials.length > 0 && (
              <div data-testid="shop-materials">
                <h2 className={`${style.heading} text-xl text-slate-900 mb-3`}>Materiali e tecniche</h2>
                <div className="flex flex-wrap gap-2">
                  {crafter.materials.map((m) => (
                    <span key={m} className={`px-3 py-1.5 ${style.btn === 'rounded-none' ? '' : 'rounded-full'} bg-shop-primary/10 text-shop-primary text-sm font-medium`}>{m}</span>
                  ))}
                </div>
              </div>
            )}
            <div className="flex flex-wrap gap-3 text-sm text-slate-600">
              {crafter.city && <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border"><MapPin className="w-4 h-4 text-shop-primary" />{crafter.city}{crafter.region ? `, ${crafter.region}` : ''}</span>}
              {crafter.founded_year && <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border"><Calendar className="w-4 h-4 text-shop-primary" />Dal {crafter.founded_year}</span>}
              {/* Certificazioni Made in Italy scelte nel profilo (elenco predefinito, verificabile da Rarifex) */}
              {(crafter.certifications || []).filter((c) => CERTIFICATIONS[c]).map((c) => (
                <span key={c} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white border"><Award className="w-4 h-4 text-shop-accent" />{CERTIFICATIONS[c].label}</span>
              ))}
            </div>
          </div>
          <div className="lg:col-span-2 space-y-4">
            <ShopVideo url={crafter.presentation_video} title={`Video di ${name}`} />
            {photos.slice(0, 4).map((src, i) => (
              <div key={i} className={`aspect-[4/3] ${style.media} overflow-hidden bg-slate-100`}>
                <img src={optimizeImageUrl(src, 900)} alt={`${name} - foto ${i + 1}`} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </Section>
    </div>
  );
}
